import { makeAutoObservable, runInAction } from "mobx";
import { rootContainer, TYPE } from "../services/container/root";
import ReportService, { IReport, IReportFiltersType, REPORT_TYPES } from "../services/api/report-service";

class ReportStore {
	private _isLoading: boolean = false;
	private _isGenerating: boolean = false;
	private _lastGenerated?: IReport;
	private _trackingId?: number;
	private _timeDelayMs: number = 10000;

	constructor(private type: REPORT_TYPES, private getReportFilters?: () => IReportFiltersType) {
		makeAutoObservable(this, {}, { autoBind: true });
	}

	private get service(): ReportService {
		return rootContainer.get<ReportService>(TYPE.ReportService);
	}

	public get isLoading() {
		return this._isLoading;
	}

	public get isGenerating() {
		return this._isGenerating;
	}

	public async generateReport() {
		try {
			this._isGenerating = true;
			const reportResponse = await this.service.generateReport(this.type, this.getReportFilters?.());
			if (reportResponse.report_url) {
				window.open(reportResponse.report_url);
				const lastReport = await this.service.lastReport(this.type);
				runInAction(() => {
					this._lastGenerated = lastReport.last_report;
					this._isGenerating = false;
				});
			} 
			else {
				this.startTracking();
			}
		} catch (error) {
			runInAction(() => {
				this._isGenerating = false;
			});
		}
	}

	public get lastGenerated() {
		return this._lastGenerated;
	}

    public getLastGeneratedUTCString(): string {
        return this._lastGenerated?.updated_at ?? '';
    }
    
	public async load() {
		try {
			this._isLoading = true;
			const lastReport = await this.service.lastReport(this.type);
			runInAction(() => {
				if (lastReport.is_new_generating) {
					this.startTracking();
				} 
				this._isLoading = false;
				this._lastGenerated = lastReport.last_report;
			});
		} catch (error) {
			runInAction(() => {
				this._isLoading = false;
			});
		}
	}

	private startTracking(): void {
		this._isGenerating = true;
		window.clearInterval(this._trackingId);
		this._trackingId = window.setInterval(this.trackInProgress, this._timeDelayMs);
	}

	private async trackInProgress() {
		const lastReport = await this.service.lastReport(this.type);
		if (lastReport.last_report?.file_path && !lastReport.is_new_generating) {
			clearInterval(this._trackingId);
			runInAction(() => {
				this._isGenerating = false;
				this._lastGenerated = lastReport.last_report;
			});
			window.open(lastReport.last_report.file_path);
		}
	}
}

export default ReportStore;
